import { createSelector } from "reselect";

import { orderedSelectedLocationsSelector } from "src/selectors/section_selectors/wounds/ordered_selected_locations_selector";

/**
 * Selector to get context for the tallies we want to GET for selected location ids
 */
export const locationsTallyContextsSelector = createSelector(
  orderedSelectedLocationsSelector,
  locs => {
    return locs.map(loc => {
      return {
        locationId: loc.id
      };
    });
  }
);
